import { render, staticRenderFns } from "./PartialOptimizedDownloadModal.vue?vue&type=template&id=ddd18dc0"
import script from "./PartialOptimizedDownloadModal.vue?vue&type=script&lang=js"
export * from "./PartialOptimizedDownloadModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports